import * as angular from 'angular';
import template from "./loader.tpl.html";
import loaderCtrl from "./loader.controller";

/**
 * @file directive for loading / priming screen
 */
export default angular.module('aps.directive.loader', [loaderCtrl])
  .directive('apsLoader', loaderDef)
  .name;

/**
 * @method loaderDef
 * @description directive definition
 * @returns {{
 *  restrict: string, scope: {}, templateUrl: string,
 *  replace: boolean, controller: string, controllerAs: string,
 *  bindToController: boolean
 * }}
 */
function loaderDef() {
  return {
    restrict: 'E',
    scope: {},
    template: template,
    replace: true,
    controller: 'LoaderCtrl',
    controllerAs: 'vm',
    bindToController: true
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/components/loader/loader.directive.ts